import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../../../assets/expert-program/directory/traffic-lights.svg'
import _imports_1 from '../../../../assets/expert-program/directory/browser-actions.svg'


const _hoisted_1 = { class: "px-4" }
const _hoisted_2 = {
  id: "unevenGridContainer",
  class: "flex flex-col w-full mx-auto bg-white"
}
const _hoisted_3 = {
  id: "directoryPreview",
  class: "flex flex-col items-center pt-2 pr-2 pl-3.5 text-xs whitespace-nowrap text-zinc-700 max-md:pr-5"
}
const _hoisted_4 = { class: "flex flex-col bg-gray-200 w-full rounded-t-lg px-2" }
const _hoisted_5 = { class: "flex flex-row justify-start gap-2 ml-2 pt-2 pt-3" }
const _hoisted_6 = { class: "flex flex-row bg-white rounded-t-2xl w-full justify-between max-w-xs p-1" }
const _hoisted_7 = { class: "flex flex-row justify-start items-center" }
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex flex-row justify-end items-center mr-3" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "flex flex-row items-center ml-2" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "flex flex-col w-full" }
const _hoisted_15 = { class: "flex flex-row justify-start items-center gap-2 ml-2 py-2" }
const _hoisted_16 = { class: "flex flex-row bg-gray-100 w-full p-1 rounded-full items-center whitespace-nowrap overflow-ellipsis overflow-hidden" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "ml-2 overflow-hidden" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "flex flex-col gap-1 text-base justify-center items-center self-stretch py-6 mx-auto text-violet-600 rounded-md w-full max-w-full" }
const _hoisted_21 = { class: "flex flex-row flex-1 w-full" }
const _hoisted_22 = { class: "flex flex-col items-center" }
const _hoisted_23 = { class: "w-full overflow-hidden" }
const _hoisted_24 = {
  key: 1,
  class: "w-full overflow-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DirectoryHeader = _resolveComponent("DirectoryHeader")!
  const _component_StaticSearchFilters = _resolveComponent("StaticSearchFilters")!
  const _component_ProfileCard = _resolveComponent("ProfileCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              loading: "lazy",
              src: _imports_0,
              class: "object-fit shrink-0 self-stretch my-auto",
              alt: ""
            }, null, -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    loading: "lazy",
                    src: _ctx.logoFromWebsite(_ctx.userStore.companyWebsite || ''),
                    class: "w-8 h-8 mr-2 rounded-full"
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.userStore.companyName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", { innerHTML: _ctx.CLOSE_ICON_SM }, null, 8, _hoisted_11)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                innerHTML: _ctx.PLUS_ICON,
                class: "text-gray-600"
              }, null, 8, _hoisted_13)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[1] || (_cache[1] = _createElementVNode("img", {
              loading: "lazy",
              src: _imports_1,
              class: "object-fit shrink-0 self-stretch my-auto",
              alt: ""
            }, null, -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                innerHTML: _ctx.LOCK_ICON,
                class: "text-gray-600 ml-2"
              }, null, 8, _hoisted_17),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.layout.websiteUrl || _ctx.userStore.companyWebsite) + "/experts", 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                innerHTML: _ctx.BROWSER_MENU_ICON,
                class: "text-gray-600 ml-2"
              }, null, 8, _hoisted_19)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          (_ctx.layout.directoryHeaderCosmetic.isVisible)
            ? (_openBlock(), _createBlock(_component_DirectoryHeader, {
                key: 0,
                boldness: _ctx.layout.directoryHeaderCosmetic.bold,
                fontFamily: _ctx.layout.directoryHeaderCosmetic.fontFamily,
                textColor: _ctx.layout.directoryHeaderCosmetic.textColor,
                backgroundColor: _ctx.layout.directoryHeaderCosmetic.backgroundColor,
                headerFontSize: _ctx.layout.directoryHeaderCosmetic.headerFontSize,
                paragraphFontSize: 
              _ctx.layout.directoryHeaderCosmetic.paragraphFontSize
            ,
                headlineText: _ctx.layout.directoryHeaderCosmetic.headerText,
                paragraphText: _ctx.layout.directoryHeaderCosmetic.paragraphText
              }, null, 8, ["boldness", "fontFamily", "textColor", "backgroundColor", "headerFontSize", "paragraphFontSize", "headlineText", "paragraphText"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_StaticSearchFilters, {
              isEnabled: _ctx.layout.showSearchFilters,
              textColor: _ctx.layout.directoryCosmetic.textColor,
              backgroundColor: _ctx.layout.directoryCosmetic.backgroundColor
            }, null, 8, ["isEnabled", "textColor", "backgroundColor"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.getLayoutSettings(_ctx.layout).isGridUneven)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "flex-1 flex gap-2 bg-gray-100 p-6 justify-center",
                  style: _normalizeStyle({
                transform:
                  _ctx.expandedLayoutId === _ctx.layout.id && _ctx.layout.layoutType === 'row'
                    ? 'scale(0.5)'
                    : 'none',
                transformOrigin: 'left top',
                width:
                  _ctx.expandedLayoutId === _ctx.layout.id && _ctx.layout.layoutType === 'row'
                    ? '200%'
                    : '100%',
              })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLayoutSettings(_ctx.layout).columns, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: n,
                      class: "space-y-3"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProfilesForLayout(_ctx.layout).filter(
                    (_, index) =>
                      index % _ctx.getLayoutSettings(_ctx.layout).columns === n - 1
                  ), (profile) => {
                        return (_openBlock(), _createBlock(_component_ProfileCard, {
                          key: profile.id,
                          profile: profile,
                          isCentered: _ctx.getLayoutSettings(_ctx.layout).profileCenterAligned,
                          isGridUneven: _ctx.getLayoutSettings(_ctx.layout).isGridUneven,
                          profileImageClass: 
                    _ctx.getLayoutSettings(_ctx.layout).profileImageClass
                  ,
                          profileImageAndNameLayoutClass: 
                    _ctx.getLayoutSettings(_ctx.layout).profileImageAndNameLayoutClass
                  ,
                          fontFamily: _ctx.layout.directoryCosmetic.fontFamily,
                          boldness: _ctx.layout.directoryCosmetic.bold,
                          textColor: _ctx.layout.directoryCosmetic.textColor,
                          backgroundColor: _ctx.layout.directoryCosmetic.backgroundColor,
                          top3MeetingsExperts: _ctx.profiles.slice(0, 3),
                          fontSize: _ctx.layout.directoryCosmetic.fontSize
                        }, null, 8, ["profile", "isCentered", "isGridUneven", "profileImageClass", "profileImageAndNameLayoutClass", "fontFamily", "boldness", "textColor", "backgroundColor", "top3MeetingsExperts", "fontSize"]))
                      }), 128))
                    ]))
                  }), 128))
                ], 4))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", {
                    class: "flex flex-wrap gap-2 bg-gray-100 p-6 justify-center",
                    style: _normalizeStyle({
                  transform:
                    _ctx.expandedLayoutId === _ctx.layout.id &&
                    _ctx.layout.layoutType === 'row'
                      ? 'scale(0.5)'
                      : 'none',
                  transformOrigin: 'left top',
                  width:
                    _ctx.expandedLayoutId === _ctx.layout.id &&
                    _ctx.layout.layoutType === 'row'
                      ? '200%'
                      : '100%',
                })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProfilesForLayout(_ctx.layout), (profile) => {
                      return (_openBlock(), _createBlock(_component_ProfileCard, {
                        key: profile.id,
                        profile: profile,
                        isCentered: _ctx.getLayoutSettings(_ctx.layout).profileCenterAligned,
                        isGridUneven: _ctx.getLayoutSettings(_ctx.layout).isGridUneven,
                        profileImageClass: 
                    _ctx.getLayoutSettings(_ctx.layout).profileImageClass
                  ,
                        profileImageAndNameLayoutClass: 
                    _ctx.getLayoutSettings(_ctx.layout).profileImageAndNameLayoutClass
                  ,
                        fontFamily: _ctx.layout.directoryCosmetic.fontFamily,
                        boldness: _ctx.layout.directoryCosmetic.bold,
                        textColor: _ctx.layout.directoryCosmetic.textColor,
                        backgroundColor: _ctx.layout.directoryCosmetic.backgroundColor,
                        top3MeetingsExperts: _ctx.profiles.slice(0, 3),
                        fontSize: _ctx.layout.directoryCosmetic.fontSize
                      }, null, 8, ["profile", "isCentered", "isGridUneven", "profileImageClass", "profileImageAndNameLayoutClass", "fontFamily", "boldness", "textColor", "backgroundColor", "top3MeetingsExperts", "fontSize"]))
                    }), 128))
                  ], 4)
                ]))
          ])
        ])
      ])
    ])
  ]))
}